import React, { useEffect, useState } from "react";
import {
  RadioGroup,
  FormControlLabel,
  Radio,
  Typography,
  TextField,
  InputAdornment
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { SUBPAGES } from "./constants";

interface SSOToggleAndSearchProps {
  activePage: string;
  onPageChange: (event: React.ChangeEvent<HTMLInputElement>, subpage: string) => void;
  handleSearch: (searchTerm: string) => void;
  clearSearch: boolean;
}

export default function SSOToggleAndSearch({
  activePage,
  onPageChange,
  handleSearch,
  clearSearch
}: SSOToggleAndSearchProps) {
  const [searchTerm, setSearchTerm] = useState('');

  const handleKeyPress = (e: any) => {
    if (e.key === 'Enter') {
        handleSearch(searchTerm);
    }
  };

  const handleSearchTermChange = (newSearchTerm: string) => {
    const didClearSearch = (!newSearchTerm && !!searchTerm);
    setSearchTerm(newSearchTerm);
    
    if (didClearSearch) {
        handleSearch('');
    }
  }

  useEffect(() => {
    if (clearSearch) {
        setSearchTerm('');
    }
  }, [clearSearch])

  return (
    <>
      <RadioGroup
        sx={{
          display: "flex",
          flexDirection: "row",
        }}
        name="controlled-radio-buttons-group"
        aria-label={activePage}
        value={activePage}
        onChange={onPageChange}
      >
        {Object.values(SUBPAGES).map((subpage: any) => {
          return (
            <FormControlLabel
              key={subpage.value}
              value={subpage.value}
              control={<Radio />}
              label={<Typography variant="body2">{subpage.text}</Typography>}
            />
          );
        })}
      </RadioGroup>
      <TextField
        type="search"
        variant="outlined"
        margin="normal"
        onKeyPress={handleKeyPress}
        onChange={(event) => handleSearchTermChange(event.target.value)}
        value={searchTerm}
        placeholder="Type in a search term and hit enter"
        slotProps={{
          input: {
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }
        }}
      />
    </>
  );
}
